export function getStreamUrl(streamName) {
  return `https://streaming.chartec.net/hls/${streamName}.m3u8`;
}

export async function checkStreamLive(streamName) {
  const streamUrl = getStreamUrl(streamName);
  try {
    const resp = await fetch(streamUrl);
    if (resp.status !== 200) {
      throw new Error("Stream file missing.");
    }
  } catch (e) {
    return false;
  }
  return true;
}



// WEBPACK FOOTER //
// ./app/javascript/libs/streams.ts